
export const UseValidationPw = (email, newPassword, currentPassword) => {

    const hasLetters = /[A-Za-z]/.test(newPassword);
    const hasSpecials = /[!@#$%^&*]/.test(newPassword);
    const hasNumbers = /\d/.test(newPassword);

    const checkEmailPasswordSimilarity = newPassword?.includes(email?.split('@')[0]);

    const regEx = [hasLetters, hasSpecials, hasNumbers].filter(Boolean).length;

    if (checkEmailPasswordSimilarity) {
        return {result: false, msg: ['It cannot contain the same characters as the email.']};
    } else if (currentPassword === newPassword) {
        return {result: false, msg: ['The new password cannot be the same as the current password.']};
    } else if (regEx >= 3 && newPassword.length >= 8) {
        return {result: true};
    } else if (regEx >= 2 && newPassword.length >= 10) {
        return {result: true};
    }
    return {result: false, msg: ['Must be 8+ characters including letters, numbers, and symbols.', 'Must be 10+ characters including any two of letters, numbers, and symbols.']};
};